import {_dropCommonHtml} from "./Common_Fun";

let PageDropCtl = {
    /**
     * 获取控件的html
     * @param formType 表单类型 分查询表单 和普通表单
     * @param item 选项
     * @param targetObj 可能是GoingForm对象 也可能是QueryForm对象
     */
    getHtml: function (formType, item, targetObj) {
        return this.getEditorHtml(item, targetObj);
    },
    //获取显示值
    getShowValue(curVal) {
        return curVal;
    },
    /**
     * 获取编辑模式下的html代码
     * @param item
     * @param targetObj
     * @returns {string}
     */
    getEditorHtml: function (item, targetObj) {
        return _dropCommonHtml(
            item,
            targetObj,
            "go-ctl-page-drop",
            "ivu-icon ivu-icon-ios-arrow-down"
        );
    },
    /**
     * 初始化提交数据
     * @param item
     * @param targetObj 目标form对象
     * @param backJson 返回的数据
     * @param formType 表单类型
     */
    getSubmitData: function (
        item,
        targetObj,
        backJson,
        formType
    ) {
        if (formType === "query") {
            this.getQuerySubmitData(item, targetObj, backJson);
        } else {
            this.getEditorSubmitData(item, targetObj, backJson);
        }
    },
    getRealValue(value) {
        return value || " ";
    },
    clearData(item, formType, targetObj) {
        let inputElId = `${targetObj.prefixCls}_${item["id"]}`;
        $("#" + inputElId).val("");
    },
    getQuerySubmitData: function (item, targetObj, backJson) {
        this.getEditorSubmitData(item, targetObj, backJson);
    },
    getEditorSubmitData: function (item, targetObj, backJson) {
        let inputElId = `${targetObj.prefixCls}_${item["id"]}`;
        backJson[item["id"]] = $("#" + inputElId).val();
    },
    initCtlEvent: function () {
    }
};

export default PageDropCtl;



// WEBPACK FOOTER //
// ./goingsrc/jsCom/goForm/components/go-page-drop.js